<template>
	<div>
		
		<div class='track__header'>
			<div class='track__title'>Выкопировка из таксационного описания</div>
			<!-- <div class='track__button-block'>
				<p-button label='Удалить файл' @click='remove' class='p-button-sm'/>
			</div> -->
		</div>

		<div class='track__content'>

			<div>{{ taxFile ? taxFile.name : '' }}</div>

<!-- 			<div v-for='track in trackList'>

				<table>
					<tbody>
						<tr>
							<td>{{ track.name }}</td>
							<td><custom-p-checkbox v-model='track.checked'/></td>
						</tr>
					</tbody>
				</table>

			</div> -->

		</div>

		<div class='track__button-block'>
				<p-button label='Удалить файл' icon='fa fa-trash' @click='remove' class='p-button-sm p-button-danger' :disabled='!actLpoIsDraft'/>
			</div>

	</div>
</template>

<script>
	const ROOT_API = process.env.VUE_APP_ROOT_API;
	const TAX_REMOVE_FILE = ROOT_API + 'load_file/tax_remove_file.php';

	export default {
		name: 'ActUploadTax',

		props: {
			currentLpo: Object,
			taxFile: null
		},

		computed: {
			actLpoIsDraft() { return this.$store.getters['lpoData/actLpoIsDraft']; },
		},	

		methods: {
			remove() {

				// console.log(this.taxFile);
				// return;

				if (!this.taxFile) return;

				const form = new FormData();
				form.append('lpo_id', this.currentLpo.lpo_id);
				form.append('image_list', JSON.stringify([ this.taxFile ]));

				fetch(TAX_REMOVE_FILE, {
					credentials: 'include',
					method: 'post',
					body: form
				})
				.then( res => this.$emit('removed'));
			}
		}
	};
</script>

<style scoped>
	.track__header {
		/*border-bottom: 1px solid black;*/
		/*padding-bottom: 0.5rem;*/
		margin-bottom: 1rem;

		font-size: 1rem;
		font-weight: bold;
		color: #6c757d;

		display: flex;
		align-items: flex-end;
		justify-content: space-between;
		flex-wrap: wrap;
		gap: 1rem;
	}

	.track__content {
		display: flex;
		/*justify-content: center;*/
		flex-wrap: wrap;
		gap: 1rem;
		margin-bottom: 1rem;
	}
</style>